import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/60/thumb-landscape.jpg"

const Post60 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">
        GUCCI／ダイアナ<br></br>
        ミニ：W20× H16× D9 (cm)／スモール：W27× H23× D9 (cm)／ミディアム：W35× H29× D13 (cm)
      </span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
            夏の強い日差しが落ち着き、朝夕の空気に少しずつ秋の気配を感じる9月。ファッションも「夏の軽やかさ」から「秋の深み」へと移ろう時期です。この季節の変わり目に、装いを一気に格上げしてくれるのが、GUCCI（グッチ）の名品「DIANA（ダイアナ）」シリーズのトートバッグです。<br></br><br></br>
            プリンセス・ダイアナに愛された歴史を持ち、現代に再解釈されたこのバッグは、エレガンスとモダンを兼ね備え、秋ファッションに欠かせない存在になっています。<br></br><br></br>
            この記事では、「グッチ ダイアナ」のミニ・スモール・ミディアムの3サイズを徹底解説します。サイズごとの収納力や、開閉口・付属ストラップの特徴、さらに秋におすすめのコーディネートもご紹介します。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2 style={{color: "#0a9186"}}>目次</h2>
        <p>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>1 |</span>&nbsp;&nbsp;時代を超えて愛されるエレガンス「グッチ ダイアナ」のストーリー</ScrollLink><br></br>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>2 |</span>&nbsp;&nbsp;秋にぴったりの3サイズを徹底比較</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec3" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ミニサイズ収納例</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec4" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;スモールサイズ収納例</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec5" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ミディアムサイズ収納例</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec6" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;付属ストラップ・開閉口・レザーベルトについて</ScrollLink><br></br>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec7" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>3 |</span>&nbsp;&nbsp;秋の始まりにおすすめのコーディネート6点</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec8" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ミニサイズコーディネート2点</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec9" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;スモールサイズコーディネート2点</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec10" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ミディアムサイズコーディネート2点</ScrollLink><br></br>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec11" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>4 |</span>&nbsp;&nbsp;まとめ：この秋をともに歩む「グッチ ダイアナ」</ScrollLink><br></br>
          </div>
        </p>
      </div>         
      <figure name="sec1">
        <StaticImage src="../../images/posts/60/1.jpg" alt=""/>
      </figure>    
      <div className="text-max-width">
        <h1>時代を超えて愛されるエレガンス「グッチ ダイアナ」のストーリー</h1>
      </div>
      <p className="text-max-width">「グッチ ダイアナ」と聞いて、ピンとくる方も多いのではないでしょうか。このバッグは、伝説的なファッションアイコン、ダイアナ妃が愛用していたことで知られるトートバッグを再解釈し、現代に蘇らせたモデルです。</p>
      <p className="text-max-width">クラシカルな竹のハンドルと、レザーのストラップでかたどられた独特のフォルムは、一見するとシンプルなデザインですが、そこに宿る上品さと品格は、まさに唯一無二です。時代を超えて女性を魅了し続ける普遍的な美しさが、このバッグには詰まっています。</p>
      <p className="text-max-width space-bottom">そして、2021年のリバイバルでは、竹のハンドルを彩るネオンカラーのレザーストラップが大きな話題を呼びました。伝統と革新が見事に融合したデザインは、クラシカルでありながら、今の時代を生きる私たちの心に響く、遊び心とモードなエッセンスを与えてくれます。</p>
      <div name="sec2" className="img-three-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/60/2.jpg" alt=""/>
          <span className="text-center">
            ミニサイズ<br></br>
            W20 x H16 x D9 (cm)
          </span>  
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/60/2_1.jpg" alt=""/>
          <span className="text-center">
            スモールサイズ<br></br>
            W27 x H23 x D9 (cm)
          </span>  
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/60/2_2.jpg" alt=""/>
          <span className="text-center">
            ミディアムサイズ<br></br>
            W35 x H29 x D13 (cm)
          </span>  
        </figure>
      </div>  
      <div className="text-max-width">
        <h1>秋にぴったりの3サイズを徹底比較</h1>
      </div>
      <p className="text-max-width space-bottom">
        グッチ ダイアナは、現在、主に3つのサイズで展開されています。それぞれのサイズ感、収納力、そしてどんなシーンにマッチするかを詳しくご紹介します。<br></br>
        どのサイズにも共通しているのは、竹のハンドルと取り外し可能なショルダーストラップです。クロスボディや肩掛けも可能で、着こなしや気分に合わせてスタイルを変えられるのが嬉しいポイントです。
      </p>
      <figure name="sec3">
        <StaticImage src="../../images/posts/60/3.jpg" alt=""/>
        <span className="text-center">GUCCI／ダイアナ ミニ／W20× H16× D9 (cm)</span>
      </figure>   
      <div className="text-max-width">
        <h2>◆ 【ミニサイズ収納例】</h2>
      </div>
      <p className="text-max-width">小さな見た目ながら、驚くほど計算された収納力を備えたのがダイアナ ミニです。お出かけに欠かせない 「必要最小限」 のアイテムがきちんと収まります。</p>
      <p className="text-max-width">
      （収納例）<br></br>
        <ul className="list-style-disc">
          <li>スマートフォン</li>
          <li>ミニ財布</li>
          <li>ミニポーチ（リップ、ミラー、ハンドクリームなど）</li>
          <li>ハンカチ</li>
          <li>ワイヤレスイヤホン</li>
        </ul>
      </p>
      <p className="text-max-width space-bottom">これだけのアイテムを入れてもバッグはすっきりとしたフォルムをキープできます。小さなバッグにありがちな「パンパンに膨らんで不格好」という心配もありません。まさに、ランチやショッピング、ちょっとしたお呼ばれなど、秋の軽やかなお出かけに寄り添う一品です。</p>
      <figure name="sec4">
        <StaticImage src="../../images/posts/60/4.jpg" alt=""/>
        <span className="text-center">GUCCI／ダイアナ スモール／W27× H23× D9 (cm)</span>
      </figure>   
      <div className="text-max-width">
        <h2>◆ 【スモールサイズ収納例】</h2>
      </div>
      <p className="text-max-width">程よい収納力とエレガントな存在感を兼ね備えたスモールサイズは、この秋の定番バッグとしてもっとも活躍するサイズ感です。A5サイズの手帳やポーチも無理なく収まり、仕事とプライベートの両方にシームレスに寄り添ってくれる万能さが魅力です。</p>
      <p className="text-max-width">
      （収納例）<br></br>
        <ul className="list-style-disc">
          <li>スマートフォン</li>
          <li>長財布</li>
          <li>キーケース</li>
          <li>A5手帳</li>
          <li>ポーチ（リップ3本・ファンデーションコンパクト・ミラー・ハンドクリームなど）</li>
          <li>ハンカチ</li>
          <li>ワイヤレスイヤホン</li>
          <li>折り畳み傘</li>
        </ul>
      </p>
      <p className="text-max-width space-bottom">これだけ入れてもフォルムは美しく保たれ、バッグが膨らんで見えることはありません。オンタイムはきちんと感を、オフタイムは洗練された抜け感を演出し、秋のお出かけをよりスタイリッシュに引き立ててくれます。</p>
      <figure name="sec5">
        <StaticImage src="../../images/posts/60/5.jpg" alt=""/>
        <span className="text-center">GUCCI／ダイアナ ミディアム／W35× H29× D13 (cm)</span>
      </figure>   
      <div className="text-max-width">
        <h2>◆ 【ミディアムサイズ収納例】</h2>
      </div>
      <p className="text-max-width">しっかりとした容量を備えたミディアムは、働く女性やアクティブに過ごす方にふさわしい存在感を放ちます。ノートPCやA4書類も収まり、出張や会食が増える秋の立ち上がりにこそ頼れるサイズ感です。バッグ自体のエレガントなデザインが、ビジネスシーンに信頼感を、プライベートには気品を添えてくれます。</p>
      <p className="text-max-width">
      （収納例）<br></br>
        <ul className="list-style-disc">
          <li>スマートフォン</li>
          <li>長財布</li>
          <li>キーケース</li>
          <li>ポーチ（リップ3本・ファンデーションコンパクト・ミラー・ハンドクリームなど）</li>
          <li>ハンカチ</li>
          <li>ワイヤレスイヤホン</li>
          <li>折り畳み傘</li>
          <li>ノートパソコン（奥行き22cm×横幅31cm）</li>
          <li>メガネ</li>
        </ul>
      </p>
      <p className="text-max-width space-bottom">これだけのアイテムを入れても型崩れしにくく、フォルムはきちんとしたままです。ノートパソコンについても奥行き22cm×横幅31cm以内であればスマートに収納可能で、ビジネスバッグとしての実用性も十分です。まさに、“仕事もプライベートも妥協しない”一品といえるでしょう。</p>
      <div name="sec6" className="text-max-width">
        <h2>◆ 付属ストラップ・開閉口・レザーベルトについて</h2>
      </div>
      <div className="text-wide-img-cloumn-main space-bottom">
        <figure className="img-small">
          <StaticImage src="../../images/posts/60/6.jpg" alt=""/>
        </figure>
        <div>
          <p><span className="text-border-bottom">付属ストラップ（2種類）</span></p>
          <p>
            <ul className="list-style-disc">
              <li>
                ウェブストライプストラップ<br></br>
                （長さ：約90～142cm）
              </li>
              <li>
                レザーストラップ<br></br>
                （長さ：約93～109cm）
              </li>
            </ul>
          </p> 
          <p>シェリーラインは「緑・赤・緑」または「青・赤・青」のストライプ柄を指します。 別名「ウェブライン」や「リボンライン」ともいい、馬具の腹帯からインスピレーションを受けデザインされました。シーンやコーディネートに合わせて付け替えが可能。ショルダーやクロスボディなど、スタイルに合わせて自在に楽しめます。</p> 
        </div>
      </div>
      <div className="text-wide-img-cloumn-main space-bottom">
        <figure className="img-small">
          <StaticImage src="../../images/posts/60/7.jpg" alt=""/>
        </figure>
        <div>
          <p><span className="text-border-bottom">フラップ開閉で安心感をプラス</span></p>
          <p>
            開閉口はフラップ仕様になっており、中身が見えにくくセキュリティ面でも安心です。デザイン性だけでなく実用性も兼ね備えています。バッグの中身をしっかりカバーしながら、上品な印象を与えてくれます。<br></br>
            そして、間口も広めなのでサイズ問わず、物を出し入れしやすいです。
          </p> 
        </div>
      </div>
      <div className="text-wide-img-cloumn-main space-bottom">
        <figure className="img-small">
          <StaticImage src="../../images/posts/60/8.jpg" alt=""/>
        </figure>
        <div>
          <p><span className="text-border-bottom">レザーベルトがポイント</span></p>
          <p>グッチ ダイアナの特徴でもあるハンドル部分のベルトは、1947年に誕生したバンブーバッグの収納用バンドに着想を得てデザインされました。レザーベルトのみの別売りや、イニシャル刻印サービスも用意されており、その日の気分やコーディネートに合わせて付け替えて楽しめます。</p> 
        </div>
      </div>
      <div name="sec7" className="text-max-width">
        <h1>秋の始まりにおすすめのコーディネート6点</h1>
      </div>
      <p className="text-max-width">グッチ ダイアナは、秋ファッションを完成させるキーアイテムです。サイズごとに異なる魅力を持っているので、どのサイズを選んでも共通しているのは、クラシカルとモダンの融合というグッチならではの美学です。秋の始まりにふさわしい「新しい私」を演出してくれるでしょう。</p>
      <div className="border" style={{borderBottom: "3px solid #333"}}></div> 
      <div name="sec8" className="text-max-width">
        <h2>◆ 【ミニサイズコーディネート2点】</h2>
      </div>
      <p className="text-max-width space-bottom">軽やかに旬を楽しみたい方におすすめです。コンパクトながら洗練された存在感で、日常のお出かけを華やかに彩ります。</p>
      <p className="text-max-width"><span className="text-font-bolder text-border-bottom">1、秋の始まりを彩るワントーンスタイル</span></p>
      <p className="text-max-width">グレーのニットトップスとワイドパンツを合わせたワントーンコーデは、落ち着きと季節感を演出できます。白スニーカーで軽快さをプラスし、都会的な抜け感を叶えます。キャップやメガネでこなれ感を出しつつ、ゴールドアクセサリーで女性らしさも忘れない大人のカジュアルスタイルです。</p>
      <div className="text-img-cloumn-main space-bottom">
        <figure className="img-small">
          <StaticImage src="../../images/posts/60/9.jpg" alt=""/>
        </figure>
        <div>
          <p><span className="text-font-bolder text-border-bottom">差し色で魅せるグッチ ダイアナ</span></p>
          <p>アクセントとして映えるのがイエローカラーです。グレーのコーデに鮮やかなカラーが加わることで華やかさと視線を集める効果を発揮します。バンブーハンドルのクラシカルなムードとスポーティーな装いのミックスが洗練された秋の着こなしを完成させます。</p> 
          <p><span className="text-font-bolder text-border-bottom">おすすめのシーン</span></p>
          <p>週末のカフェ巡りや友人とのランチ、ちょっとしたショッピングなど、カジュアルでアクティブなシーンにおすすめのスタイルです。</p> 
        </div>
      </div>
      <p className="text-max-width"><span className="text-font-bolder text-border-bottom">2、秋色プリントで魅せるフェミニンスタイル</span></p>
      <p className="text-max-width">水彩画のようなニュアンスカラーのプリントワンピースは、柔らかな雰囲気で秋の始まりをエレガントに彩ります。動きに合わせて揺れるシルエットが、女性らしいしなやかさを演出します。足元はストラップパンプスを合わせて、クラシカルなムードをプラスしました。</p>
      <div className="text-img-cloumn-main space-bottom">
        <figure className="img-small">
          <StaticImage src="../../images/posts/60/10.jpg" alt=""/>
        </figure>
        <div>
          <p><span className="text-font-bolder text-border-bottom">洗練さを添えるグッチ ダイアナ</span></p>
          <p>コーディネートのアクセントとなるのが、グッチ ダイアナ ミニ トートバッグ（イエロー）です。バンブーハンドルがクラシカルな存在感を放ちつつ、秋色ワンピースと好相性です。ネイビーカラーの入ったスカーフを添えることでバッグとのカラーバランスもより一層引き立ちます。</p> 
          <p><span className="text-font-bolder text-border-bottom">おすすめのシーン</span></p>
          <p>アート展やホテルでのアフタヌーンティー、特別感のあるディナーなど、上品でフェミニンな雰囲気を楽しみたいシーンにぴったりのスタイルです。</p> 
        </div>
      </div>
      <div className="border"></div> 
      <div name="sec9" className="text-max-width">
        <h2>◆ 【スモールサイズコーディネート2点】</h2>
      </div>
      <p className="text-max-width space-bottom">知的で上品な印象を求める女性にぴったりです。オフィスやきちんと感のある場面でもスマートに寄り添います。</p>
      <p className="text-max-width"><span className="text-font-bolder text-border-bottom">3、カジュアルに映えるブルーカーディガンスタイル</span></p>
      <p className="text-max-width">鮮やかなブルーのクロップドカーディガンに、バイカラーデニムを合わせた爽やかなカジュアルコーデです。シンプルなホワイトキャミソールをインナーに取り入れることで、抜け感のある大人カジュアルが完成します。足元はチェーンローファーでクラシカルさをひとさじプラスしました。パールピアスや腕時計で上品さを添えれば、シンプルながらも洗練された印象になります。</p>
      <div className="text-img-cloumn-main space-bottom">
        <figure className="img-small">
          <StaticImage src="../../images/posts/60/11.jpg" alt=""/>
        </figure>
        <div>
          <p><span className="text-font-bolder text-border-bottom">深みのあるブラウンで魅せるグッチ ダイアナ</span></p>
          <p>コーディネートの引き締め役となるのが、グッチ ダイアナ スモール トートバッグ（ブラウン）です。鮮やかなブルーとのコントラストが映え、全体に落ち着きと品格をプラスしてくれます。バンブーハンドルの存在感が、カジュアルな装いを格上げし、大人らしい余裕を演出してくれます。</p> 
          <p><span className="text-font-bolder text-border-bottom">おすすめのシーン</span></p>
          <p>休日のショッピングや友人とのランチ、ちょっとした小旅行など、カジュアルながらもきちんと感を持たせたいシーンにおすすめのスタイルです。</p> 
        </div>
      </div>
      <p className="text-max-width"><span className="text-font-bolder text-border-bottom">4、深みグリーンで魅せるエレガントスタイル</span></p>
      <p className="text-max-width">シアー感のあるグリーンのロングワンピースは、秋の始まりにふさわしい華やぎと落ち着きを兼ね備えた一枚です。女性らしいラインを引き立てつつ、フレアスリーブがドラマティックな雰囲気を演出します。足元にはベージュのロングブーツを合わせることで、シーズンムードを盛り上げながら上品にまとまります。ゴールドアクセサリーが加わることで、リュクスな大人の装いになります。</p>
      <div className="text-img-cloumn-main space-bottom">
        <figure className="img-small">
          <StaticImage src="../../images/posts/60/12.jpg" alt=""/>
        </figure>
        <div>
          <p><span className="text-font-bolder text-border-bottom">落ち着きカラーで引き締めるグッチ ダイアナ</span></p>
          <p>コーディネートを格上げするのが、グッチ ダイアナ スモール トートバッグ（ブラウン）です。深みのあるグリーンと相性抜群で、全体に安定感とシックな表情をプラスしてくれます。バンブーハンドルのクラシカルなムードがロングワンピースの優雅さをより引き立て、秋の装いに気品を添えます。</p> 
          <p><span className="text-font-bolder text-border-bottom">おすすめのシーン</span></p>
          <p>ディナーデートやホテルでのアフタヌーンティー、観劇などのお出かけにぴったりです。シンプルな小物を合わせることでワンピースとバッグの存在感を存分に楽しめるスタイルです。</p> 
        </div>
      </div>
      <div className="border"></div> 
      <div name="sec10" className="text-max-width">
        <h2>◆ 【ミディアムサイズコーディネート2点】</h2>
      </div>
      <p className="text-max-width space-bottom">堂々とした存在感を演出したい方にふさわしい選択です。仕事から特別な場面まで、華やかさと品格を兼ね備えたスタイルを叶えてくれます。</p>
      <p className="text-max-width"><span className="text-font-bolder text-border-bottom">5、マスタードイエローで差し込む華やぎスタイル</span></p>
      <p className="text-max-width">ニュアンスのあるグレージュのトップスは、程よい肌見せと柔らかな素材感で、抜け感を演出できます。そこに鮮やかなマスタードイエローのワイドパンツを合わせれば、視線を惹きつける華やぎをプラスしながら、モードな雰囲気に仕上がります。足元はボリューム感のあるスニーカーで外しを効かせ、軽やかで都会的な印象です。ゴールドアクセサリーを添えれば、さりげなくリュクスな雰囲気が漂います。</p>
      <div className="text-img-cloumn-main space-bottom">
        <figure className="img-small">
          <StaticImage src="../../images/posts/60/13.jpg" alt=""/>
        </figure>
        <div>
          <p><span className="text-font-bolder text-border-bottom">グッチ GGキャンバスで格上げする洗練感</span></p>
          <p>存在感を放つのが、グッチ GGキャンバス×バンブーハンドルバッグです。GGパターンとナチュラルなバンブーが、パンツの鮮やかさを上品に引き締め、全体を大人のバランスへと導きます。きちんと感と遊び心を兼ね備えたデザインで、日常から特別なお出かけまで、幅広いシーンに活躍します。</p> 
          <p><span className="text-font-bolder text-border-bottom">おすすめのシーン</span></p>
          <p>ショッピングや週末のランチ、アートスポット巡りなど、気分を高めたいお出かけにぴったりです。シンプルな小物を合わせれば、パンツの華やぎとバッグのラグジュアリー感を主役にしたコーデが完成します。</p> 
        </div>
      </div>
      <p className="text-max-width"><span className="text-font-bolder text-border-bottom">6、フリルセットアップで叶えるクラシカルエレガンス</span></p>
      <p className="text-max-width">柔らかなライトベージュのセットアップは、フリルデザインが印象的で、上品さと華やぎを兼ね備えた一着です。シンプルながらも女性らしい存在感を放ち、動くたびに揺れるフリルがエレガントな雰囲気を演出します。足元にはゴールドのフラットシューズを合わせて、リラックス感の中にも華やかさをプラスします。パールアクセサリーやスカーフが、クラシカルな仕上がりをさらに高めてくれます。</p>
      <div className="text-img-cloumn-main space-bottom">
        <figure className="img-small">
          <StaticImage src="../../images/posts/60/14.jpg" alt=""/>
        </figure>
        <div>
          <p><span className="text-font-bolder text-border-bottom">グッチ ダイアナで仕上げる都会的クラシカル</span></p>
          <p>バンブーハンドルとGGキャンバスのコンビネーションが、洗練されたムードをプラスします。柔らかなベージュトーンのセットアップとも相性抜群で、秋の軽やかさを引き立てながら全体をリュクスにまとめ上げるアイテムです。オンにもオフにも映える存在感で、秋の始まりを気品ある装いに仕上げます。</p> 
          <p><span className="text-font-bolder text-border-bottom">おすすめのシーン</span></p>
          <p>美術館巡りやホテルでのランチ、友人とのラグジュアリーなお茶会などのお出かけにぴったりです。上品な小物づかいが映えるシーンで優雅さと洗練さを同時に楽しめます。</p> 
        </div>
      </div>
      <div className="border"></div> 
      <figure name="sec11">
        <StaticImage src="../../images/posts/60/15.jpg" alt=""/>
      </figure>  
      <div name="sec8" className="text-max-width">
        <h1>まとめ：この秋をともに歩む「グッチ ダイアナ」</h1>
      </div>
      <p className="text-max-width">グッチ ダイアナは、秋ファッションに欠かせない「華やぎ」を叶えてくれる存在です。ミニ・スモール・ミディアム、それぞれのサイズはライフスタイルやシーンに寄り添いながら、常に品格ある印象を与えてくれます。</p>
      <p className="text-max-width">秋の軽やかさを楽しむランチやショッピングから、特別感のあるディナーや美術館巡りまで。差し色として華やぎをプラスしたい日も、落ち着いたクラシカルな雰囲気を纏いたい日も、グッチ ダイアナはその日の気分にぴったりと寄り添います。</p>
      <p className="text-max-width">購入前に迷ったら、まずはラクサスで体験してみるのもおすすめです。実際に持ち歩いてみることで、自分に合うサイズやカラーを見極めることができます。</p>
      <p className="text-max-width">この秋、自分らしいスタイルを完成させるキーアイテムとして、ぜひ選んでみてはいかがでしょうか。</p>
      <div className="border"></div> 
      <p className="text-max-width">📱憧れを日常に──ラクサスでグッチを体験しよう！</p>     
      <Link to="https://laxus.co/app/pc/bags/gucci" className="view-all-button">グッチのバッグはこちら</Link>
    </section>
    </div>
  </div>
</Layout>
)}

export default Post60

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 60}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`